/* RESPONSIBLE TEAM: team-standalone */

import { type ComposerOverflowMenuTooltipData } from './definitions';

export const GenericComposerOverflowMenuTooltipData: ComposerOverflowMenuTooltipData = {
  icon: 'conversation',
  entityNameKey: 'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt',
  historicalCasesDisabledTooltipKey:
    'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt-salesforce-settings-tooltip',
};

export const ZendeskComposerOverflowMenuTooltipData: ComposerOverflowMenuTooltipData = {
  icon: 'zendesk',
  entityNameKey: 'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt-zendesk',
  historicalCasesDisabledTooltipKey:
    'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt-zendesk-settings-tooltip',
};

export const SalesforceComposerOverflowMenuTooltipData: ComposerOverflowMenuTooltipData = {
  icon: 'salesforce',
  entityNameKey:
    'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt-salesforce',
  historicalCasesDisabledTooltipKey:
    'inbox.ask-fin.overflow-menu-tooltip.source-filters.conversation-excerpt-salesforce-settings-tooltip',
};
